import { AuthHttp } from 'app/infrastructure/common';
import { Injectable } from '@angular/core';
import { AppSettings } from 'app/infrastructure/settings';
import { Response, RequestOptions, URLSearchParams } from '@angular/http';

@Injectable()
export class CssConfigService {
    constructor(private http: AuthHttp) { }

    getCssConfig(ownerCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('OwnerCode', ownerCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'CssConfig/GetCssConfig', options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/config/css.service.ts